module.exports = __webpack_public_path__ + "media/images/screenshots/buy-focus-7241d5f7c5562e2845905a751d0e5fd9.png";